import { usePolicy } from '../GlobalStateContext';
import React from 'react';
import { VariantsTable } from './VariantsTable';

export function VariantChoice(props: { onChoice: () => void })
{
  const policy = usePolicy();

  const insured = policy.formData.insuredPersons.safeGet(0);

  return <>
    {insured &&
      <VariantsTable
        insured={insured}
        onChange={() =>
        {
          props.onChoice();
        }}
      />
    }
  </>;
}
